import { Api } from '../config';
import {
  IResPatentRightsPage,
  IResPatentRightsDetail,
  IReqPatentRightsPage,
} from 'src/types/api/patentRightsApiTypes';
import { IReqQRCode } from 'src/types/api/qrCodeTypes';

export const patentRightsServiceProvider = () => {
  /**
   * 查詢專利權狀態異動資料。
   */
  const getPatentRights = async (params?: IReqPatentRightsPage) => {
    const res = await Api().get('/PatentRights/search', {
      params: params,
    });
    return res.data as IResPatentRightsPage;
  };

  /**
   * 查詢專利權狀態異動資料明細。
   */
  const getPatentRightsByApplNo = async (
    applNo: string,
    applyClass: string,
    qrCode: IReqQRCode,
  ) => {
    const params = {
      applNo: applNo,
      applyClass: applyClass,
      qrCode: qrCode.qrCode,
      dataNo: qrCode.dataNo,
      dataClass: qrCode.dataClass,
      uuid: qrCode.uuid,
    };
    const res = await Api().get(`/PatentRights/search/detail`, {
      params,
    });
    return res.data as IResPatentRightsDetail;
  };

  return {
    getPatentRights,
    getPatentRightsByApplNo,
  };
};
